import type { ComponentType } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { SATELLITES } from './config';
import { ensureSatelliteAnalytics } from './analytics';
import { WeekOnWeekOffPage } from './WeekOnWeekOffPage';
import { CustodySchedulePage } from './CustodySchedulePage';
import { CoparentMoneyPage } from './CoparentMoneyPage';
import { VisitationTrackerPage } from './VisitationTrackerPage';
import { CourtReadyRecordsPage } from './CourtReadyRecordsPage';
import { RateQuizPage } from './RateQuizPage';

function RateMyCoparentPage() {
  return <RateQuizPage apex='ratemycoparent.com' />;
}

function RateMyCoparentingPage() {
  return <RateQuizPage apex='ratemycoparenting.com' />;
}

const PAGES: Record<string, ComponentType> = {
  'weekonweekoff.com': WeekOnWeekOffPage,
  'custodyscheduleapp.com': CustodySchedulePage,
  'coparentmoney.com': CoparentMoneyPage,
  'visitationtracker.com': VisitationTrackerPage,
  'courtreadyrecords.com': CourtReadyRecordsPage,
  'ratemycoparent.com': RateMyCoparentPage,
  'ratemycoparenting.com': RateMyCoparentingPage,
};

export function SatelliteApp({ apex }: { apex: string }) {
  ensureSatelliteAnalytics();
  const Page = PAGES[apex];
  if (!Page || !SATELLITES[apex]) {
    return (
      <div className='flex min-h-screen items-center justify-center p-6'>
        <p>Unknown satellite host.</p>
      </div>
    );
  }
  return (
    <HelmetProvider>
        <Page />
    </HelmetProvider>
  );
}
